/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateScheduleTemplateData
 */
export interface UpdateScheduleTemplateData {
    /**
     * 
     * @type {string}
     * @memberof UpdateScheduleTemplateData
     */
    name?: string;
}

/**
 * Check if a given object implements the UpdateScheduleTemplateData interface.
 */
export function instanceOfUpdateScheduleTemplateData(value: object): value is UpdateScheduleTemplateData {
    return true;
}

export function UpdateScheduleTemplateDataFromJSON(json: any): UpdateScheduleTemplateData {
    return UpdateScheduleTemplateDataFromJSONTyped(json, false);
}

export function UpdateScheduleTemplateDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateScheduleTemplateData {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
    };
}

  export function UpdateScheduleTemplateDataToJSON(json: any): UpdateScheduleTemplateData {
      return UpdateScheduleTemplateDataToJSONTyped(json, false);
  }

  export function UpdateScheduleTemplateDataToJSONTyped(value?: UpdateScheduleTemplateData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
    };
}

